// extracted by mini-css-extract-plugin
module.exports = {"group":"_IconText_group__29k4u","text":"_IconText_text__2E2hw"};